import React from "react";
import PropTypes from 'prop-types';
import Chip from "../Chip/Chip";

interface ChipGroupProps extends React.HTMLAttributes<HTMLElement> {
    chipTexts?: Array<string>;
    isSelectable?: boolean;
    selected?: string;
    // Baseline arguments
    children?: React.ReactNode;
    className?: string;
    // Functions
    onClose?: (chipText: string) => void;
}

/**
 * An eyebrow that usually goes above headers.
 * 
 * ## _
 * ### Arguments
 * @param {Array<string>} chipTexts - An array of strings to be made into chips.
 * @param {boolean} isSelectable - A flag to turn only one tag active at a time. This is determined by the `selected` input.
 * @param {string} selected - When `isSelectable` is true, this will be the chip string that is selected.
 * @param {React.ReactNode} children - The contents inside the component. Currently, this does nothing, but exists for parity.
 * @param {string} className - CSS classes to apply to the component.
 * 
 * ## _
 * ### Functions
 * @param {function} onClose - The function to be called when a chip closes. This will pass in the respective chip text.
 */
class ChipGroup extends React.Component<ChipGroupProps> {
    static propTypes = {
        chipTexts: PropTypes.arrayOf(PropTypes.string),
        isSelectable: PropTypes.bool,
        selected: PropTypes.string,
        children: PropTypes.node,
        className: PropTypes.string,
        onClose: PropTypes.func,
    }

    static defaultProps = {
        className: "",
    }

    render() {
        const { chipTexts, isSelectable, selected, children, className, onClose, ...rest } = this.props;

        return (
            <ul className="m-chip-group">
                { chipTexts?.map((chip) => (
                    <li className="m-chip-group__chip" key={chip}>
                        <Chip
                            onClick={() => {
                                if(isSelectable) {
                                    onClose?.(chip);
                                }
                            }}
                            chipText={chip}
                            onClose={() => onClose?.(chip)}
                            isInactive={isSelectable && selected !== chip}
                            hideClose={isSelectable}
                        />
                    </li>
                ))}
            </ul>
        );
    }
}

export default ChipGroup;